var map = {
	"./australia_a_league/official.mp4": "gtzr",
	"./la_liga/official.mp4": "IBWP",
	"./premier_league/official.mp4": "ERC2",
	"./serie_a/official.mp4": "cTZU",
	"./wolves/official.mp4": "8rZl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "q0Ow";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video ^\.\/.*\/official\.mp4$
// module id = q0Ow
// module chunks = 1